import { Event } from '@/feature/event-details-sbk/types';
import { designSystem } from '@/styles/styles';
import { AtLeast } from '@/types/utils';

type TeamBranding = {
    primaryColor?: string;
    secondaryColor?: string;
    logoUrl?: string;
};

// Each field falls back on its own, so one team's missing metadata never affects the other team.
export const getTeamBranding = (team?: TeamBranding) => ({
    primary: team?.primaryColor ? team.primaryColor.toLowerCase() : designSystem.colors.neutral300,
    secondary: team?.secondaryColor ? team.secondaryColor.toLowerCase() : designSystem.colors.neutral900,
    shouldShowFallbackLogo: !team?.logoUrl,
});

export const getTeamColors = (event?: AtLeast<Event, 'home_team' | 'away_team'>) => ({
    home: getTeamBranding({
        primaryColor: event?.home_team?.primary_color,
        secondaryColor: event?.home_team?.secondary_color,
        logoUrl: event?.home_team?.logo_url,
    }),
    away: getTeamBranding({
        primaryColor: event?.away_team?.primary_color,
        secondaryColor: event?.away_team?.secondary_color,
        logoUrl: event?.away_team?.logo_url,
    }),
});
